<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<div class="k-asset-publish-status-log-container">
		<b>Publishing Status Log</b>
		<div class="k-asset-publish-status-log">
			<div v-for="(item, index) in llog" class="k-asset-publish-status-log-item" :class="[{'first' : !index}]">
				<div v-if="item.action == 'status'" class="d-flex">
					<span class="mr-1">{{ item.from }}</span>
					<v-icon class="mr-1" x-small>fas fa-arrow-right</v-icon>
					<span>{{ item.to }}</span>
					<v-spacer/>
				</div>

				<div v-else>
					Assigned to: {{ item.assigned_user_name }}
				</div>

				<div class="k-asset-publish-status-log-item-sub">By: {{ item.user_name }}</div>
				<div class="k-asset-publish-status-log-item-sub">On: {{ item.created_at }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: {
		log: {required: true}
	},

	data() {
		return {
		}
	},

	computed: {
		llog() {
			return this.log.map(x => {
				let y = object_copy(x)
				y.to = this.get_status_text(y.to)
				y.from = this.get_status_text(y.from)
				y.created_at = this.get_date_string(y.created_at)
				return y
			})
		}
	},

	mounted() {
	},

	methods: {
		get_date_string(ts) {
			// format date, converting to local timezone
			return date.format(U.convert_to_local_date(ts), 'M/D/YYYY h:mm A')
		},

		get_status_text(publish_status) {
			let o = window.get_publish_status_data(publish_status)
			return o.text
		},
	}
}
</script>

<style lang="scss">
.k-asset-publish-status-log-container {
	background-color: #fff;
	font-size: 16px;
	padding: 8px;
	border-radius: 8px;
	height: calc(100% - 32px);
	width: 240px;
}

.k-asset-publish-status-log {
	overflow: auto;
	height: calc(100% - 16px);
	width: 240px;
	max-height: 384px;
}

.k-asset-publish-status-log-item {
	margin-top: 4px;
	border-top: 1px solid #ccc;
	padding-top: 4px;
	font-size: 12px;

	&.first {
		border-top: unset;
	}
}

.k-asset-publish-status-log-item-sub {
	font-size: 12px;
}
</style>